import renderTwyneMulti from "./twyne-multi";

const renderQuestions = fields => {
  if (!fields) {
    return ''
  }

  let questions = ''
  for (const field of fields) {
    questions += `\t\t\tdata.${field.key} = '{${field.key}}';\n`;
  }
  return questions
}

function renderIfficient({ pubid, srcid, suppressredirect, istest }, { extraFields }) {
  const url = "https://ifficient.api.twyne.io"
  const questions = renderQuestions(extraFields)

  return `
  <script type="text/javascript" src="${url}/assets/path.js"></script>
  <script type="text/javascript" id="twyne-embed" class="twyne-embed">
      (function (global) {
          function twyne_load() {
              var data = {};

              data.pid = '${pubid}';
              data.sid = '${srcid}';
              data.first = '{firstName_jsescape}';
              data.last = '{lastName_jsescape}';
              data.email = '{email_jsescape}';
              data.address1 = '{address1_jsescape}';
              data.address2 = '{address2_jsescape}';
              data.city = '{city_jsescape}';
              data.gender = '{gender_urlencoded}',
              data.state = '{state_urlencoded}';
              data.zip = '{zip_urlencoded}';
              data.country = 'US';
              data.phone = '{phone}';
              data.dob = '{dob_slashes_mmddyyyy_urlencoded}';
              data.istest = '${istest ? 'y' : 'n'}';
              data.externalgroup = '{pe_key}';
              data.subid1 = '{pid}';
              data.subid2 = '{sid1}';
              data.optout = '{optout}';
              data.checkers = '{checkers}';

              // return URL for when a user completes the path
              data.rurl = '{nextURL_urlencoded}';
              data.embedUrlOverride = '${url}';

${questions}

              global.twyne.initEmbed(data);
          }

          twyne_load();
      })(this);
  </script>
  `.trim()
}

export default (config, integrationData) => {
  if (integrationData.dynamicNavigation) {
    return renderTwyneMulti({
      url: "https://ifficient.api.twyne.io",
      ...config,
    }, integrationData)
  }

  return renderIfficient(config, integrationData)
};
